import { LoaderBar, PageHeader } from 'components'
import { Form } from 'semantic-ui-react'
import { useState } from 'react'
import {
    GetDueTemplatesList,
    GetUserListForGroup,
    GetCustomerList,
} from 'hooks'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { FormDateField, FormDropdownField, SubmitCancelButtons } from 'elements'
import { DueTemplatesList } from 'page-components'
import { DatePickerTypes, DateUtility } from 'utility'

const DueTemplatesSchema = yup.object().shape({
    StartDate: yup
        .string()
        .required('Start date required')
        .typeError('Start date required'),

    EndDate: yup
        .string()
        .required('End date required')
        .typeError('End date required'),

    UserId: yup.string().required('User is required').nullable(),

    CustomerId: yup.string().required('Customer is required').nullable(),
})

export const DueTemplatesScreen = () => {
    const {
        data,
        loading,
        filterChanged,
        filter,
        totalCount,
        pageChanged,
        setData,
    } = GetDueTemplatesList()
    const { options: userOptions } = GetUserListForGroup()
    const { options: customerOptions } = GetCustomerList()
    const [processing, setProcessing] = useState('')

    const {
        control,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(DueTemplatesSchema),
        defaultValues: {
            StartDate: new Date(),
            EndDate: new Date(),
            UserId: null,
            CustomerId: null,
        },
    })
    const startDateValue = watch('StartDate')

    const submit = formData => {
        const startDate = new Date(formData.StartDate)
        const endDate = new Date(formData.EndDate)

        const startDateISO = DateUtility.dateToLocalISO(
            DateUtility.startDay(startDate),
        )

        const endDateISO = DateUtility.dateToLocalISO(
            DateUtility.endDay(endDate),
        )

        filterChanged({
            StartDate: startDateISO,
            EndDate: endDateISO,
            StatusList: '1;2;3;',
            DashboardReportType: 2,
            UserId: formData.UserId ? parseInt(formData.UserId, 10) : undefined,
            customerIds: formData.CustomerId
                ? parseInt(formData.CustomerId, 10)
                : undefined,
        })
    }

    const resetForm = async () => {
        reset({
            StartDate: new Date(),
            EndDate: new Date(),
            UserId: null,
            CustomerId: null,
        })
        setData([])
        setProcessing('')
    }

    // eslint-disable-next-line no-unused-vars
    const onReopen = async item => {
        setProcessing('Reopening')
        try {
            // Handle reopen logic if needed
        } catch (error) {
            console.error('Error reopening:', error)
        } finally {
            setProcessing('')
        }
    }

    // eslint-disable-next-line no-unused-vars
    const onReject = async item => {
        setProcessing('Rejecting')
        try {
            // Handle reject logic if needed
        } catch (error) {
            console.error('Error rejecting:', error)
        } finally {
            setProcessing('')
        }
    }

    // eslint-disable-next-line no-unused-vars
    const onRemove = async id => {
        setProcessing('Processing')
        try {
            // Handle remove logic if needed
        } catch (error) {
            console.log(error)
        } finally {
            setProcessing('')
        }
    }

    // eslint-disable-next-line no-unused-vars
    const onEdit = async item => {
        // Handle edit logic if needed
    }

    // eslint-disable-next-line no-unused-vars
    const onViewReport = async item => {
        // Handle view report logic if needed
    }

    return (
        <>
            <div className="">
                <PageHeader header="Due Templates" />
                <Form noValidate>
                    <Form.Group widths="equal">
                        <FormDateField
                            name="StartDate"
                            control={control}
                            label="Start Date"
                            errors={errors.StartDate}
                            type={DatePickerTypes.Single}
                        />
                        <FormDateField
                            name="EndDate"
                            control={control}
                            label="End Date"
                            disabledBefore={startDateValue}
                            errors={errors.EndDate}
                            type={DatePickerTypes.Single}
                        />
                        <FormDropdownField
                            name="UserId"
                            control={control}
                            label="User"
                            placeholder="Select User"
                            options={userOptions}
                            errors={errors.UserId}
                            selection
                            required
                        />
                        <FormDropdownField
                            name="CustomerId"
                            control={control}
                            label="Customer"
                            placeholder="Select Customer"
                            options={customerOptions}
                            errors={errors.CustomerId}
                            selection
                            required
                        />
                    </Form.Group>
                    <div className="pt-1">
                        <SubmitCancelButtons
                            onSubmit={handleSubmit(submit)}
                            onCancel={resetForm}
                            className=""
                        />
                    </div>
                </Form>
            </div>
            <div className="my-3">
                <DueTemplatesList
                    data={data}
                    filter={filter}
                    onReopen={onReopen}
                    totalCount={totalCount}
                    pageChanged={pageChanged}
                    onRemove={onRemove}
                    onEdit={onEdit}
                    onViewReport={onViewReport}
                    onReject={onReject}
                />
                {(processing || loading) && (
                    <LoaderBar content={processing || 'Loading'} />
                )}
            </div>
        </>
    )
}
